import PropTypes from "prop-types";
import classNames from "classnames";
import PrimaryButtonAnimation from "./PrimaryButtonAnimation/PrimaryButtonAnimation";
import classes from "./PrimaryButtons.module.css";

const PrimaryButton = (props) => {
  const { withAnimation, children, className, ...rest } = props;
  return (
    <button className={classNames(classes["primary-btn"], className)} {...rest}>
      {children}
      {withAnimation && <PrimaryButtonAnimation />}
    </button>
  );
};

export default PrimaryButton;

PrimaryButton.propTypes = {
  withAnimation: PropTypes.bool,
  className: PropTypes.string,
};
